import { Button, createStyles, Dialog, DialogActions, DialogContent, DialogTitle, StyledComponentProps, withStyles } from '@material-ui/core';
import { observer } from 'mobx-react';
import { Instance, types } from 'mobx-state-tree';
import * as React from 'react';
import { PleaseWait } from '../../comps/PleaseWait';
import { transl } from '../../main/transl';
import { getOmnistore } from '../../stores/Omnistore';

const ReminderDialogStore = types
	.model('ReminderDialogStore', {
		isVisible: false,
		isPending: false,
		id: 0,
		templateId: 0,
		isShared: false,
		status: types.enumeration(['NEW', 'ACTIVE', 'INACTIVE']),
		nextAlarm: types.maybe(types.string),
	})
	.views(self => ({
		get isValid() {
			return true;
		},
	}))
	.actions(self => ({
		accept() {

		},
		cancel() {

		},
	}));

export const reminderDialogStore = ReminderDialogStore.create({status: 'NEW'});

@observer class _ReminderDialog extends React.Component<{store: Instance<typeof reminderDialogStore>} & StyledComponentProps> {
	componentDidMount() {
		getOmnistore().multirepo.reminderRepo.fetch();
	}

	render() {
		const {classes, store} = this.props;
		if (!classes) return null; // impossible
		if (!store.isVisible) return null;
		if (store.isPending) return <Dialog open={true} className={classes.root} fullWidth><PleaseWait/></Dialog>;
		return <Dialog open={true} className={classes.root} onClose={store.cancel} fullWidth>
			<DialogTitle>{transl('createTemplate')}</DialogTitle>
			<DialogContent className={classes.content}>
			</DialogContent>
			<DialogActions>
				<Button onClick={store.accept} disabled={!store.isValid} color="primary">
					{transl('createTemplate.accept')}
				</Button>
				<Button onClick={store.cancel}>{transl('cancel')}</Button>
			</DialogActions>
		</Dialog>;
	}
}

const styles = createStyles({
	root: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'stretch',
	},
	content: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'stretch',
		width: '100%',
	},
	input: {
		width: '100%',
		margin: 10,
	},
});

export const ReminderDialog = withStyles(styles)(_ReminderDialog);
